import { render, staticRenderFns } from "./commonMsg.vue?vue&type=template&id=380a3375&"
import script from "./commonMsg.vue?vue&type=script&lang=js&"
export * from "./commonMsg.vue?vue&type=script&lang=js&"
import style0 from "./commonMsg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports